module.exports = __webpack_public_path__ + "img/upgrade1.8bfde065.png";